module.exports = __webpack_public_path__ + "static/media/Norway.aa18920d.png";